import es from '@/config/languages/es';

import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContext';

export const useTranslation = () => {
  const {
    state: { dictionaryValues },
  } = useConfigContext();

  const hasTranslation = (textId: keyof typeof es) => {
    if (dictionaryValues[textId]) return true;
    return false;
  };

  const getTextIdTranslation = (textId: keyof typeof es) => {
    const caseSimilarTranslation =
      typeof textId === 'string' && (dictionaryValues[textId.toUpperCase()] || dictionaryValues[textId.toLowerCase()]);
    return dictionaryValues[textId] || caseSimilarTranslation || '';
  };

  return {
    getTextIdTranslation,
    hasTranslation,
  };
};

export type GetTextIdTranslationType = (textId: keyof typeof es) => string;
